import {
  MdCalendarToday,
  MdHeadset,
  MdOutlinePayment,
  MdOutlineTextSnippet,
  MdPersonOutline,
} from "react-icons/md";
import { Link } from "react-router-dom";

const ProfileOverview = () => {
  const topItems = [
    {
      name: "Account Settings",
      icon: <MdPersonOutline />,
      path: "/main/profile/account-settings",
      description: "Manage your account settings",
    },
    {
      name: "Subscription Billing",
      icon: <MdOutlinePayment />,
      path: "/main/profile/subscription-billing",
      description: "Manage your subscription billing",
    },
    {
      name: "Post Scheduling Preferences",
      icon: <MdCalendarToday />,
      path: "/main/profile/post-scheduling-preferences",
      description: "Set your post scheduling preferences",
    },
  ];
  const bottomItems = [
    {
      name: "Data & Privacy",
      icon: <MdOutlineTextSnippet />,
      path: "/main/profile/data-privacy",
      description: "Manage your data and privacy",
    },
    {
      name: "Help & Support",
      icon: <MdHeadset />,
      path: "/main/profile/help-support",
      description: "Get help and support",
    },
  ];
  const Settings = ({ name, icon, path, description, isBottom }) => {
    return (
      <Link
        className={`${
          isBottom ? "col-span-6" : "col-span-4"
        } flex min-h-[160px] w-full flex-col justify-between rounded-[14px] bg-gradient-to-b from-gray-50 to-purple-50 p-4 shadow-md transition-all duration-300 hover:from-gray-100  hover:to-purple-100 lg:!mb-0`}
        to={path}
      >
        <div className="h-4 w-4 text-lg text-gray-800 dark:text-white">
          {icon}
        </div>
        <div>
          <div className="text-lg font-bold text-gray-900">{name}</div>
          <div className="text-sm text-gray-500">{description}</div>
        </div>
      </Link>
    );
  };
  return (
    <div className="flex w-full flex-col gap-5">
      <div className="w-ful mt-3 flex h-fit flex-col gap-5 lg:grid lg:grid-cols-12">
        {topItems.map((item) => (
          <Settings
            key={item.name}
            name={item.name}
            icon={item.icon}
            path={item.path}
            description={item.description}
          />
        ))}
      </div>
      <div className="w-ful mt-3 flex h-fit flex-col gap-5 lg:grid lg:grid-cols-12">
        {bottomItems.map((item) => (
          <Settings
            isBottom={true}
            key={item.name}
            name={item.name}
            icon={item.icon}
            path={item.path}
            description={item.description}
          />
        ))}
      </div>
    </div>
  );
};

export default ProfileOverview;
